/* eslint func-names: 0 */
import Cookie from 'common/services/util/-RFC.Cookie';
import Timers from 'common/services/util/-RFC.Timers';
import eventManager from 'common/services/-RFC.eventManager';

angular.module('services')
    .factory(
        'SessionManagement',
        ($modal, $rootScope, $interval) => {

            const SessionManagement = {

                start() {

                    const self = this;
                    this.userInactive = false;
                    eventManager.subscribe('session:extended:reset', function () {

                        _.bind(this.restartInactivityTimer, this);

                    });

                    eventManager.subscribe('auth:login', (data) => {

                        self.setSessionTimer(data);
                        self.__startSessionInterval();
                        self.__startInactivityInterval();

                    });

                },

                expire() {

                    eventManager.broadcast('session:expired');
                    this.__openSessionExpiredModal();

                },

                setSessionTimer(data) {

                    let ttlSession;
                    if (data) {

                        ttlSession = data.data.expires_in * CWCONFIG.session.ttlToMiliseconds;
                        if (ttlSession > 60000) {

                            this.sessionTimeout = ttlSession - 60000;

                        } else {

                            this.sessionTimeout = 5000; // set default session expire at 10 seconds

                        }

                    }

                },

                /*
                Starts session timer. At certain intervals, call refresh session
            */
                __startSessionInterval() {

                    this.sessionInterval = $interval(
                        _.bind(this.__refreshSession, this),
                        this.sessionTimeout,
                    );
                    Timers.intervals.push(this.sessionInterval);

                },

                /**
                Start the timer for user inactivity
            */
                __startInactivityInterval() {

                    const self = this;
                    this.inactivityInterval = $interval(() => {

                        self.userInactive = true;

                    }, CWCONFIG.session.userInactivityTimer); // add constant here
                    Timers.intervals.push(this.inactivityInterval);

                },

                /**
                Checks if remember me token is present or if the user is active.
                Based on that, it silently refreshes
                the session or it is displaying the Session Expired Lightbox
            */
                __refreshSession() {

                    // if (
                    //     $location.path() === '/auth/login' ||
                    //     $location.path() === 'auth/forgot'
                    // ) {
                    //     return;
                    // }
                    if (!Cookie.get(CWCONFIG.cookie.token) || this.userInactive) {

                        // this triggered the session expired view. This should be replaced
                        // replace with an alert or with a modal
                        $interval.cancel(this.sessionInterval);
                        this.expire();

                    }

                },

                __openSessionExpiredModal() {

                    $modal.open({
                        template: require('../../../views/modals/session-expired.html'),
                        controller: 'SessionExpire',
                        backdrop: 'static',
                        keyboard: false,
                        windowClass: 'white-modal',
                        resolve: {
                            modalParams() {

                                return 'session-expired';

                            },
                        },
                    });

                },

                /**
             * Clear the former inactivity interval and starts a new one. Call this when
             * a new socket event is triggered, but except refresh session
             */
                restartInactivityTimer() {

                    $interval.cancel(this.inactivityInterval);
                    this.__startInactivityInterval();

                },

                /*
             * Resets session timer and sets the user as active
             */
                restartSessionTimer() {

                    this.__startSessionInterval();
                    this.userInactive = false;

                },
            };

            return SessionManagement;

        },
    );



// WEBPACK FOOTER //
// ./scripts/common/services/SessionManagement.js